import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { useContext } from "react";
import {
  GetStaffResult,
  getStaff,
  getTaxes,
  GetTaxesResult,
  updateFeatureFlag,
  UpdateFeatureFlagPayload,
  getStripeBillingCustomerId,
  GetStripeBillingCustomerIdResult,
  getClientGymTypeSubType,
  ClientGymTypeSubType,
} from "./clientApi";
import { AppContext } from "../context/app";

export function useStaffQuery(options?: UseQueryOptions<GetStaffResult>) {
  const app = useContext(AppContext);
  return useQuery<GetStaffResult>({
    ...options,
    queryKey: ["staff"],
    queryFn: () => getStaff(app.client!.uuid),
  });
}

export function useTaxesQuery(options?: UseQueryOptions<GetTaxesResult>) {
  const app = useContext(AppContext);
  return useQuery<GetTaxesResult>({
    ...options,
    queryKey: ["taxes"],
    queryFn: () => getTaxes(app.client!.uuid),
  });
}

export function useUpdateFeatureFlagMutation(
  options?: UseMutationOptions<void, unknown, UpdateFeatureFlagPayload>,
) {
  const app = useContext(AppContext);
  return useMutation({
    ...options,
    mutationFn: async (payload: UpdateFeatureFlagPayload) => {
      await updateFeatureFlag(app.client!.uuid, payload.name, payload.value);
    },
  });
}

export function useGetStripeBillingCustomerIdQuery(
  options?: UseQueryOptions<GetStripeBillingCustomerIdResult>,
) {
  return useQuery<GetStripeBillingCustomerIdResult>({
    ...options,
    queryKey: ["stripeBillingCustomerId"],
    queryFn: () => getStripeBillingCustomerId(),
  });
}

export function useGetClientGymTypeSubType(
  options?: UseQueryOptions<ClientGymTypeSubType, Error>
) {
  return useQuery<ClientGymTypeSubType, Error>({
    queryKey: ["clientGymTypeSubType"],
    queryFn: () => getClientGymTypeSubType(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 3,
    ...options,
  });
}
